import styles from './Spacer.module.scss';

export const Spacer = () => <div className={styles.spacer} />;
